module.exports = __webpack_public_path__ + "img/messages.59031b6.png";